// Path to the root of the app from the generated HTML page
__webpack_public_path__ = "../../";

import "../polyfill";

import { app } from "../DynamicsApp";
import { appOverrides } from "../PowerApps/AppOverrides";
import { Config } from "../configuration";

window.dynamicsOfficeBuild = {
    buildVersion: Config.BuildVersion,
    buildType: Config.BuildType,
    details: Config.BuildCommit
};

(<any>window).app = app;
appOverrides.overrides.overrideApp();

window.history.forward();
window.onload = app.onDocumentReady;
Office.initialize = function (reason: Office.InitializationReason) {
    app.componentReady(app.RequiredComponents.Office);
};
